import { Route, Routes } from 'react-router-dom';

import { ACTION_NEEDED_ROUTES } from '../../contants/routes';
import ActionNeededLayouts from '../layouts/ActionNeededLayouts';
import ShipmentApproveRejectPage from '../pages/ActionsNeeded/ShipmentApproveRejectPage';

const ActionNeededRoutes = () => {
  return (
    <Routes>
      <Route path={ACTION_NEEDED_ROUTES.BASE} element={<ActionNeededLayouts />}>
        <Route
          exact
          path={ACTION_NEEDED_ROUTES.BASE + ACTION_NEEDED_ROUTES.SHIPMENT_APPROVAL_REJECTION}
          element={<ShipmentApproveRejectPage />}
        />
      </Route>
    </Routes>
  );
};

export default ActionNeededRoutes;
